import { SecurityFeature } from '@cast/types';

import { useSingleClusterSettingsQuery } from 'hooks/queries/security-insights/useSingleClusterSettingsQuery';

export const useClusterSecurityFeatures = ({
  clusterId,
  enabled,
}: {
  clusterId: string;
  enabled?: boolean;
}) => {
  const { settings, isLoading, error, refetch } = useSingleClusterSettingsQuery(
    {
      clusterId,
      enabled,
    }
  );
  return {
    isComplianceChecksEnabled: !!settings?.features?.includes(
      SecurityFeature.CONFIGURATION_SCANNING
    ),
    isVulnerabilityDetectionEnabled: !!settings?.features?.includes(
      SecurityFeature.IMAGE_SCANNING
    ),
    features: settings?.features ?? [],
    isLoading,
    error,
    refetch,
  };
};
